import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { QueryResponse, QueryRequest, TableSchema, TableSchemaCriteria } from '../../models';

export enum SqlQueryActionTypes {
  LoadDatabaseSchemas = '[SqlQuery] Load Database Schemas',
  LoadDatabaseSchemasSuccess = '[SqlQuery] Load Database Schemas Success',
  LoadDatabaseSchemasFailure = '[SqlQuery] Load Database Schemas Failure',

  RunSqlQuery = '[SqlQuery] Run Sql Query',
  RunSqlQuerySuccess = '[SqlQuery] Run Sql Query Success',
  RunSqlQueryFailure = '[SqlQuery] Run Sql Query Failure'
}

export class LoadDatabaseSchemas implements Action {
  readonly type = SqlQueryActionTypes.LoadDatabaseSchemas;
  constructor(public payload: TableSchemaCriteria) {}
}

export class LoadDatabaseSchemasSuccess implements Action {
  readonly type = SqlQueryActionTypes.LoadDatabaseSchemasSuccess;
  constructor(public payload: TableSchema[]) {}
}

export class LoadDatabaseSchemasFailure implements Action {
  readonly type = SqlQueryActionTypes.LoadDatabaseSchemasFailure;
  constructor(public payload: any) {}
}
export class RunSqlQuery implements Action {
  readonly type = SqlQueryActionTypes.RunSqlQuery;
  constructor(public payload: QueryRequest) {}
}

export class RunSqlQuerySuccess implements Action {
  readonly type = SqlQueryActionTypes.RunSqlQuerySuccess;
  constructor(public payload: QueryResponse) {}
}

export class RunSqlQueryFailure implements Action {
  readonly type = SqlQueryActionTypes.RunSqlQueryFailure;
  constructor(public payload: any) {}
}

export type SqlQueryActions =
  | LoadDatabaseSchemas
  | LoadDatabaseSchemasFailure
  | LoadDatabaseSchemasSuccess
  | RunSqlQuery
  | RunSqlQueryFailure
  | RunSqlQuerySuccess;
